// Optimized resizeImage function for text recognition
export const resizeImage = (imageDataUrl, maxWidth = 1200, maxHeight = 1200, quality = 0.85) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      // Skip processing if image is already small enough
      if (img.width <= maxWidth && img.height <= maxHeight) {
        console.log('Image already small enough, no resize needed');
        resolve(imageDataUrl);
        return;
      }
      
      // Calculate new dimensions while maintaining aspect ratio
      let width = img.width;
      let height = img.height;
      
      if (width > maxWidth) {
        height = Math.round((height * maxWidth) / width);
        width = maxWidth;
      }
      
      if (height > maxHeight) {
        width = Math.round((width * maxHeight) / height);
        height = maxHeight;
      }
      
      // Create canvas and resize image
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      
      const ctx = canvas.getContext('2d');
      // Use better quality settings
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';
      ctx.drawImage(img, 0, 0, width, height);
      
      // For text recognition, PNG might preserve details better than JPEG
      // But if file size is a concern, use higher quality JPEG
      const resizedImageDataUrl = canvas.toDataURL('image/jpeg', quality);
      
      console.log(`Image resized from ${img.width}x${img.height} to ${width}x${height}`);
      
      // Log size reduction
      const originalSize = imageDataUrl.length;
      const newSize = resizedImageDataUrl.length;
      const reduction = ((originalSize - newSize) / originalSize * 100).toFixed(1);
      console.log(`Size reduced by ${reduction}% (${Math.round(originalSize/1024)}KB → ${Math.round(newSize/1024)}KB)`);
      
      resolve(resizedImageDataUrl);
    };
    
    img.onerror = (e) => {
      console.error('Error loading image for resizing:', e);
      reject(new Error('Failed to load image for resizing'));
    };
    
    img.src = imageDataUrl;
  });
};

export const enhanceImage = (imageDataUrl) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      
      const ctx = canvas.getContext('2d');
      
      // Draw original image
      ctx.drawImage(img, 0, 0);
      
      // Get image data for processing
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const data = imageData.data;
      
      // Simple image enhancement - increase contrast and brightness
      for (let i = 0; i < data.length; i += 4) {
        // Increase contrast
        data[i] = Math.max(0, Math.min(255, (data[i] - 128) * 1.2 + 128)); // Red
        data[i+1] = Math.max(0, Math.min(255, (data[i+1] - 128) * 1.2 + 128)); // Green
        data[i+2] = Math.max(0, Math.min(255, (data[i+2] - 128) * 1.2 + 128)); // Blue
      }
      
      // Put the modified data back
      ctx.putImageData(imageData, 0, 0);
      
      // Convert to high-quality JPEG
      const enhancedImageDataUrl = canvas.toDataURL('image/jpeg', 0.95);
      resolve(enhancedImageDataUrl);
    };
    
    img.onerror = (e) => {
      console.error('Error enhancing image:', e);
      reject(new Error('Failed to enhance image'));
    };
    
    img.src = imageDataUrl;
  });
};